import Locale from 'antd/es/locale/zh_CN';
const locale = Locale.Pagination;
export default locale;